import "angular";
import "angular-ui-router";
import DependencyViewController from "./DependencyViewController";
import DependencyFilter from "./DependencyFilter";
import DependencyViewRouteStates from "./DependencyViewRouteStates";

var DependenciesModule = angular.module("DependenciesModule", [
    // Libraries
    "ngResource",
    "ui.router"
]);
// Controllers
DependenciesModule.controller("DependencyViewController", DependencyViewController)
    .filter("dependencyTreeItem", DependencyFilter)
    .config(DependencyViewRouteStates);

export default DependenciesModule;
